import { motion } from "framer-motion";
import {
  Sprout, Flame, Leaf, Soup, PackageCheck, Truck, Package, Building2,
} from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { SERVICES } from "@/data/site";

const ICONS = { Sprout, Flame, Leaf, Soup, PackageCheck, Truck, Package, Building2 };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative bg-[var(--bg)] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <Overline>What We Do</Overline>
          <h2 className="mt-5 max-w-3xl font-display text-4xl font-bold leading-[1.05] tracking-tight text-[var(--ink)] sm:text-5xl">
            Wholesale services built for businesses.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-[var(--border)] bg-[var(--border)] sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
                className="group relative bg-[var(--bg)] p-8 transition-colors duration-300 hover:bg-white"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--green)]/8 text-[var(--green)] transition-all duration-300 group-hover:bg-[var(--green)] group-hover:text-white">
                  <Icon size={24} />
                </span>
                <h3 className="mt-6 font-display text-xl font-semibold text-[var(--ink)]">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[var(--ink-soft)]">{s.desc}</p>
                <span className="absolute right-6 top-8 font-display text-sm text-[var(--border)] transition-colors group-hover:text-[var(--gold)]">
                  0{i + 1}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
